<div
  class="flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md">
  <ng-content></ng-content>
</div>
